import React, { useEffect, useState } from "react";
import axios from "axios";
import { Notify } from "notiflix";
import CommonProfileCard from "../CommonProfileCard/CommonProfileCard";
import ProfileSkeleton from "../ProfileSkeleton/ProfileSkeleton"

const ViewedProfileSection = () => {
    const [showAll, setShowAll] = useState(() => {
        const savedShowAll = localStorage.getItem("kkm_viewed_profiles_show_all");
        return savedShowAll ? JSON.parse(savedShowAll) : false;
    });
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem("kkm_viewed_profiles_page");
        return savedPage ? Number(savedPage) : 1;
    });
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [Reload, setReload] = useState(false);

    const profilesPerPage = 30;

    useEffect(() => {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/viewed-profile-list",
                { headers }
            )
            .then((response) => {
                if (response.data.status === true) {
                    setProfiles(response.data.data);
                } else {
                    Notify.failure(response.data.message);
                }
            })
            .finally(() => setLoading(false));
    }, [Reload]);

    useEffect(() => {
        if (!loading && profiles.length > 0) {
            const lastViewedId = sessionStorage.getItem("last_viewed_profile_id");
            const savedScrollPos = sessionStorage.getItem("all_profiles_scroll_pos");

            if (lastViewedId || savedScrollPos) {
                setTimeout(() => {
                    const element = document.getElementById(`profile-card-${lastViewedId}`);
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth", block: "center" });
                    } else if (savedScrollPos) {
                        window.scrollTo({ top: Number(savedScrollPos), behavior: "smooth" });
                    }
                    sessionStorage.removeItem("last_viewed_profile_id");
                    sessionStorage.removeItem("all_profiles_scroll_pos");
                }, 150);
            }
        }
    }, [loading, profiles]);

    const indexOfLastProfile = currentPage * profilesPerPage;
    const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
    const currentProfiles = showAll
        ? profiles.slice(indexOfFirstProfile, indexOfLastProfile)
        : profiles.slice(0, 4);

    const totalPages = Math.ceil(profiles.length / profilesPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            localStorage.setItem("kkm_viewed_profiles_page", page.toString());
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5;
        const half = Math.floor(maxPagesToShow / 2);

        let start = Math.max(1, currentPage - half);
        let end = Math.min(totalPages, start + maxPagesToShow - 1);

        if (end - start + 1 < maxPagesToShow) {
            start = Math.max(1, end - maxPagesToShow + 1);
        }

        if (start > 1) {
            pages.push(1);
            if (start > 2) pages.push("...");
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < totalPages) {
            if (end < totalPages - 1) pages.push("...");
            pages.push(totalPages);
        }

        return pages;
    };

    const handleViewAllClick = () => {
        setShowAll(true);
        setCurrentPage(1);
        localStorage.setItem("kkm_viewed_profiles_show_all", "true");
        localStorage.setItem("kkm_viewed_profiles_page", "1");
    };

    const handleShowLessClick = () => {
        setShowAll(false);
        setCurrentPage(1);
        localStorage.setItem("kkm_viewed_profiles_show_all", "false");
        localStorage.setItem("kkm_viewed_profiles_page", "1");
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className="all-profiles-section">
            <h2>Viewed Profile List ({profiles.length})</h2>
            <div className="row profiles-grid">
                {loading
                    ? Array(4)
                          .fill(null)
                          .map((_, i) => (
                              <div className="col-xl-6 col-12 mb-4" key={i}>
                                  <ProfileSkeleton />
                              </div>
                          ))
                    : currentProfiles.map((profile, index) => (
                          <div className="col-xl-6 col-12 mb-4" key={index}>
                              <CommonProfileCard
                                  profile={profile}
                                  setReload={setReload}
                              />
                          </div>
                      ))}
            </div>
            {!loading && !showAll && profiles.length > 4 && (
                <div className="view-all-wrapper">
                    <button className="view-all-btn" onClick={handleViewAllClick}>
                        View All
                    </button>
                </div>
            )}
            {!loading && showAll && (
                <>
                    {profiles.length > profilesPerPage && (
                        <nav className="d-flex justify-content-center mt-4">
                            <ul className="pagination shadow-sm rounded-3">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                        Prev
                                    </button>
                                </li>
                                {getPageNumbers().map((page, i) => (
                                    <li
                                        key={i}
                                        className={`page-item ${currentPage === page ? "active" : ""} ${
                                            page === "..." ? "disabled" : ""
                                        }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => typeof page === "number" && handlePageChange(page)}
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
                    <div className="view-all-wrapper mt-3">
                        <button className="view-all-btn" onClick={handleShowLessClick}>
                            Show Less
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default ViewedProfileSection;
